
import widgetDateMixin from "@/mixins/widget-date"
import { getLocalTzOffsetMs } from "@/utils/date"

function formatDate (date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, "0")
  const day = String(date.getDate()).padStart(2, "0")
  return `${year}-${month}-${day}T00:00:00.000Z`
}

export default widgetDateMixin.extend({
  props: {
    isPlain: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    date: {
      get (): string | undefined {
        if (!this.model) return undefined

        if (typeof this.model === "number") {
          const fixed = this.isPlain
            ? this.model
            // + 4 часа + смещение текущего пояса
            : this.model + 14400000 + getLocalTzOffsetMs()
          return formatDate(new Date(fixed)).split("T")[0]
        }

        if (typeof this.model === "string")
          return this.model.split("T")[0]

        return undefined
      },

      set (date: string) {
        if (!date) {
          this.model = undefined
          return
        }

        this.model = this.isPlain
          ? date
          : `${date}T00:00:00.000Z`
      },
    },
  },
})
